/// <reference path="../types/rum.d.ts" />

'use client'

import React, {useContext, useEffect} from 'react'

import {HistoryContext} from '@yandex-delivery/core/history/context'
import {rumCounterInitJs, rumObservableClassName} from './counter'
import {rumErrorInitJs} from './error'
import {logEvent} from './event'
import {BROWSER_formatRumPageName} from './shared'
import type {RumMiddlewareOutput} from './types'
import {getRumPage, GLOBAL_OBJ, parseRumPageVar, setRumPage} from './utils'

// FYI: Если подключить, то ломает HMR в dev-режиме
const disableRUM = process.env.NODE_ENV === 'development'

const [commentStart, commentEnd] = disableRUM ? ['/* ', ' */'] : ['', '']

const NON_SENSETIVE_ATTRS = ['id', 'class', 'role', 'name', 'alt', 'aria-label', 'title', 'disabled']
const TEST_ATTRS = ['data-testid', 'data-e2e']

const getClickMarkup = ({target}: MouseEvent) => {
  if (target instanceof Element) {
    const testAttr = TEST_ATTRS.find(attr => target.hasAttribute(attr))
    logEvent(
      'click',
      testAttr
        ? `[${testAttr}="${target.getAttribute(testAttr)}"]`
        : NON_SENSETIVE_ATTRS.reduce(
            (selector, attr) =>
              target.hasAttribute(attr) ? selector + `[${attr}="${target.getAttribute(attr)}"]` : selector,
            target.tagName.toLowerCase(),
          ),
    )
  }
}

export const RumObservableRoot: React.FC<React.PropsWithChildren<{}>> = ({children}) => {
  const history = useContext(HistoryContext)

  useEffect(() => {
    GLOBAL_OBJ.document!.addEventListener('click', getClickMarkup, false)

    return () => {
      GLOBAL_OBJ.document!.removeEventListener('click', getClickMarkup)
    }
  }, [])

  useEffect(() => {
    history?.listen(({pathname}) => {
      const [serviceName] = parseRumPageVar()

      setRumPage(
        serviceName === 'account' ? BROWSER_formatRumPageName(pathname, serviceName) : `${serviceName}.unknown`,
      )
      logEvent('nav', getRumPage())
    })
  }, [history])

  return <div className={rumObservableClassName}>{children}</div>
}

export const Rum: React.FC<{nonce?: string; config: RumMiddlewareOutput}> = ({
  nonce,
  config: {
    config: {rumCounter, errorCounter},
    inlineJs,
    bundleSrc,
  },
}) => (
  <>
    <script dangerouslySetInnerHTML={{__html: inlineJs.rumCounter}} nonce={nonce} />
    <script
      dangerouslySetInnerHTML={{__html: [commentStart, rumCounterInitJs(rumCounter), commentEnd].join('')}}
      nonce={nonce}
    />
    {!disableRUM && <script crossOrigin="anonymous" nonce={nonce} src={bundleSrc} />}
    {inlineJs.mfpObserver && (
      <script
        dangerouslySetInnerHTML={{__html: [commentStart, inlineJs.mfpObserver, commentEnd].join('')}}
        nonce={nonce}
      />
    )}
    <script
      dangerouslySetInnerHTML={{__html: [commentStart, rumErrorInitJs(errorCounter), commentEnd].join('')}}
      nonce={nonce}
    />
  </>
)
